import { render, staticRenderFns } from "./ehc-file-input.vue?vue&type=template&id=c030975a&scoped=true"
import script from "./ehc-file-input.vue?vue&type=script&lang=js"
export * from "./ehc-file-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c030975a",
  null
  
)

export default component.exports